/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import PostStatus from '@linc-technologies/linced-common/enums/post-status';
import PostType from '@linc-technologies/linced-common/enums/post-type';
import { action } from '@ember/object';
import { classNames } from '@ember-decorators/component';
import { rollbackRelationships } from '@linc-technologies/linced-common/utils/record-rollback';

@classNames('post-publisher')
export default class PostPublisher extends Component {
  @service
  paperToaster;

  PostStatus = PostStatus;
  PostType = PostType;
  @tracked
  updating = false;
  @tracked
  conflictWarningOpen = false;

  @action
  publish() {
    this.updatePostStatus(PostStatus.PUBLISHED);
  }

  @action
  unpublish() {
    this.updatePostStatus(PostStatus.UNPUBLISHED);
  }

  @action
  revertToDraft() {
    this.updatePostStatus(PostStatus.DRAFT);
  }

  @action
  closeConflictWarning() {
    this.conflictWarningOpen = false;
    this.updating = false;
  }

  updatePostStatus(newStatus) {
    let toaster = this.paperToaster;
    let updatedAt = this.get('post.updateTime');
    this.updating = true;

    // Drop unsaved relationship edits before reloading, as the reload itself
    // did before WarpDrive 5.3. It now keeps them, and the save below would
    // publish them along with the status change.
    rollbackRelationships(this.post);
    this.post.reload().then((post) => {
      if (
        newStatus === PostStatus.PUBLISHED &&
        post.get('updateTime') !== updatedAt
      ) {
        // Post has been modified by somebody else - warn the user before publishing
        this.conflictWarningOpen = true;
      } else {
        post.set('status', newStatus);
        post.save().then(
          () => {
            this.updating = false;
            toaster.show(`Post status updated successfully.`, {
              duration: 4000,
              position: 'top right',
              toastClass: 'success',
            });
          },
          () => {
            toaster.show(`Failed to update post status.`, {
              duration: 4000,
              position: 'top right',
              toastClass: 'warning',
            });
            post.rollbackAttributes();
          },
        );
      }
    });
  }
}
